/**
 * Dashboard_Service.ts
 * Dashboard live counters over SSE (cookie auth — EventSource needs no header).
 */

import { Hosp_Dashboard_Stream_Url } from '../../api/endpoints';
import type { DashboardCounters } from '../../schemas/dashboard/dashboard';

export type { DashboardCounters } from '../../schemas/dashboard/dashboard';

/** Opens the dashboard SSE stream. Auth is cookie-based, so EventSource works without a manual header. */
export function openDashboardStream(onCounters: (c: DashboardCounters) => void): EventSource {
  const es = new EventSource(Hosp_Dashboard_Stream_Url, { withCredentials: true });
  es.addEventListener('counters', (ev: MessageEvent) => {
    try { onCounters(JSON.parse(ev.data)); } catch { /* ignore malformed frame */ }
  });
  return es;
}
